module.exports = __webpack_public_path__ + "img/access_5.bc20dd36.jpg";